/* angular stuff */

/* 3rd party libraries */

/* our own stuff */
import { globalVariables } from "src/app/core/constants/globalVariables";

// server url configuration
let url = {
    apiUrl: globalVariables.ERP_URL.hrApiUrl
};

// others
export const hrConfig = {
    url: url,
    defaultDateFormat: globalVariables.defaultDateFormat
    //defaultDateFormat: globalVariables.dateFormat.dateFormat
}